export const environment = {
  zipServer: 'https://zip11.zalamo.com',
};
